import datedTakeout from './reducers'

export { setDatedTakeout } from './actions'
export { getDatedTakeout } from './selectors'

export default datedTakeout
